export default __webpack_public_path__ + "static/media/plasticoceans.01cfaca6.jpg";